export const CS_OVERVIEW_SEARCH_CUSTOMER = "CS_OVERVIEW_SEARCH_CUSTOMER"; 
export const CS_OVERVIEW_SEARCH_SUPPLIER = "CS_OVERVIEW_SEARCH_SUPPLIER"; 
export const CS_OVERVIEW_SEARCH_CONTACT = "CS_OVERVIEW_SEARCH_CONTACT"; 
export const CS_OVERVIEW_SEARCH_MEMBER = "CS_OVERVIEW_SEARCH_MEMBER";
export const CS_OVERVIEW_SEARCH_ACTIVE = "CS_OVERVIEW_SEARCH_ACTIVE";
export const CS_OVERVIEW_SEARCH_INACTIVE = "CS_OVERVIEW_SEARCH_INACTIVE";
export const CS_OVERVIEW_SEARCH_TERM = "CS_OVERVIEW_SEARCH_TERM";
export const CS_OVERVIEW_SEARCH_KEYWORDS = "CS_OVERVIEW_SEARCH_KEYWORDS";
export const CS_EXPORT_FILTER_OPEN = "CS_EXPORT_FILTER_OPEN";
export const CS_EXPORT_EXPORT_OPEN = "CS_EXPORT_EXPORT_OPEN";
export const CS_EXPORT_SEARCH_CUSTOMER = "CS_EXPORT_SEARCH_CUSTOMER";
export const CS_EXPORT_SEARCH_SUPPLIER = "CS_EXPORT_SEARCH_SUPPLIER";
export const CS_EXPORT_SEARCH_CONTACT = "CS_EXPORT_SEARCH_CONTACT";
export const CS_EXPORT_SEARCH_MEMBER = "CS_EXPORT_SEARCH_MEMBER";
export const CS_EXPORT_SEARCH_ACTIVE = "CS_EXPORT_SEARCH_ACTIVE";
export const CS_EXPORT_SEARCH_INACTIVE = "CS_EXPORT_SEARCH_INACTIVE";
export const CS_EXPORT_SEARCH_TERM = "CS_EXPORT_SEARCH_TERM";
export const CS_EXPORT_SEARCH_KEYWORDS = "CS_EXPORT_SEARCH_KEYWORDS";
export const CS_EXPORT_INCLUDE_BASEDATA = "CS_EXPORT_INCLUDE_BASEDATA";
export const CS_EXPORT_INCLUDE_GENERAL = "CS_EXPORT_INCLUDE_GENERAL";
export const CS_EXPORT_INCLUDE_ADDRESS = "CS_EXPORT_INCLUDE_ADDRESS";
export const CS_EXPORT_INCLUDE_CONTACT = "CS_EXPORT_INCLUDE_CONTACT";
export const CS_EXPORT_INCLUDE_CONTACT_PERSON = "CS_EXPORT_INCLUDE_CONTACT_PERSON";
export const CS_EXPORT_INCLUDE_BILLING = "CS_EXPORT_INCLUDE_BILLING";
export const CS_EXPORT_INCLUDE_MEMBER = "CS_EXPORT_INCLUDE_MEMBER";
export const CS_EXPORT_INCLUDE_POSTAL_ADDRESS = "CS_EXPORT_INCLUDE_POSTAL_ADDRESS";
export const CS_EXPORT_INCLUDE_USER_ADMINISTRATION = "CS_EXPORT_INCLUDE_USER_ADMINISTRATION";
export const CS_EXPORT_INCLUDE_NOTICE = "CS_EXPORT_INCLUDE_NOTICE";
export const INVOIVE_MEMBERSHIP_FILTER_OPEN = "INVOIVE_MEMBERSHIP_FILTER_OPEN";
export const INVOIVE_MEMBERSHIP_STARTING = "INVOIVE_MEMBERSHIP_STARTING";
export const INVOIVE_MEMBERSHIP_ENDING = "INVOIVE_MEMBERSHIP_ENDING";
export const INVOIVE_MEMBERSHIP_CATEGORIES = "INVOIVE_MEMBERSHIP_CATEGORIES";
export const INVOICE_OVERVIEW_FILTER_OPEN = "INVOICE_OVERVIEW_FILTER_OPEN";
export const INVOICE_OVERVIEW_INVOICE_STATUS = "INVOICE_OVERVIEW_INVOICE_STATUS";
export const INVOICE_OVERVIEW_ACCOUNTING_STATUS = "INVOICE_OVERVIEW_ACCOUNTING_STATUS";
export const INVOICE_OVERVIEW_SEARCH_TERM = "INVOICE_OVERVIEW_SEARCH_TERM";
export const INVOICE_OVERVIEW_STARTING = "INVOICE_OVERVIEW_STARTING";
export const INVOICE_OVERVIEW_ENDING = "INVOICE_OVERVIEW_ENDING";
export const INVOICE_OVERVIEW_REGISTER = "INVOICE_OVERVIEW_REGISTER";
export const INVOICE_OVERVIEW_YEAR = "INVOICE_OVERVIEW_YEAR";
export const INVOICE_OVERVIEW_START_NUMBER = "INVOICE_OVERVIEW_START_NUMBER";
export const INVOICE_OVERVIEW_END_NUMBER = "INVOICE_OVERVIEW_END_NUMBER";
export const INVOICE_OVERVIEW_SEPA = "INVOICE_OVERVIEW_SEPA";

export const BUDGET_FORECAST_SELECTED_YEAR = "BUDGET_FORECAST_SELECTED_YEAR";


export const BUDGET_FORECAST_SUM_AUTO_WIDTH = "BUDGET_FORECAST_SUM_AUTO_WIDTH";
export const BUDGET_FORECAST_SUM_AUTO_EXPAND_ALL = "BUDGET_FORECAST_SUM_AUTO_EXPAND_ALL";
export const BUDGET_FORECAST_SUM_SELECT_MONTH_OPTION = "BUDGET_FORECAST_SUM_SELECT_MONTH_OPTION";
export const BUDGET_FORECAST_SUM_SHOW_MONTHLY_DIFFERENCE = "BUDGET_FORECAST_SUM_SHOW_MONTHLY_DIFFERENCE";
export const BUDGET_FORECAST_SUM_SHOW_ANNOTATION = "BUDGET_FORECAST_SUM_SHOW_ANNOTATION";
export const BUDGET_FORECAST_SUM_SHOW_YEAR = "BUDGET_FORECAST_SUM_SHOW_YEAR";
export const BUDGET_FORECAST_SUM_CHARTS = "BUDGET_FORECAST_SUM_CHARTS";
export const BUDGET_FORECAST_SHOW_SUMMARY = "BUDGET_FORECAST_SHOW_SUMMARY";

export const BUDGET_FORECAST_SHOW_YEAR_TO_DATE = "BUDGET_FORECAST_SHOW_YEAR_TO_DATE";
export const BUDGET_FORECAST_SHOW_FORECAST = "BUDGET_FORECAST_SHOW_FORECAST";


export const BUDGET_FORECAST_OVERVIEW_ACTIVE = "BUDGET_FORECAST_OVERVIEW_ACTIVE";
export const BUDGET_FORECAST_OVERVIEW_INACTIVE = "BUDGET_FORECAST_OVERVIEW_INACTIVE";
export const BUDGET_FORECAST_OVERVIEW_SEARCH_TERM = "BUDGET_FORECAST_OVERVIEW_SEARCH_TERM";

export const BUDGET_DETAIL_CONFIG_COLLAPSED = "BUDGET_DETAIL_CONFIG_COLLAPSED";
export const BUDGET_DETAIL_NOTE_FIELD_COLLAPSED = "BUDGET_DETAIL_NOTE_FIELD_COLLAPSED";
export const BUDGET_DETAIL_SINGLE_MONTH_DETAILS_COLLAPSED = "BUDGET_DETAIL_SINGLE_MONTH_DETAILS_COLLAPSED";


export const TODO_SETTINGS_NOTIFICATION_GROUP_LIST_ACTIVE_FILTER = "TODO_SETTINGS_NOTIFICATION_GROUP_LIST_ACTIVE_FILTER";
export const TODO_SETTINGS_NOTIFICATION_GROUP_LIST_INACTIVE_FILTER = "TODO_SETTINGS_NOTIFICATION_GROUP_LIST_INACTIVE_FILTER";

export const TODO_SETTINGS_NOTIFICATION_TYPE_LIST_ACTIVE_FILTER = "TODO_SETTINGS_NOTIFICATION_TYPE_LIST_ACTIVE_FILTER";
export const TODO_SETTINGS_NOTIFICATION_TYPE_LIST_INACTIVE_FILTER = "TODO_SETTINGS_NOTIFICATION_TYPE_LIST_INACTIVE_FILTER";

export const TODO_SETTINGS_NOTIFICATION_STATE_LIST_ACTIVE_FILTER = "TODO_SETTINGS_NOTIFICATION_STATE_LIST_ACTIVE_FILTER";
export const TODO_SETTINGS_NOTIFICATION_STATE_LIST_INACTIVE_FILTER = "TODO_SETTINGS_NOTIFICATION_STATE_LIST_INACTIVE_FILTER";


export const PARISH_MASS_TYPES_LIST_ACTIVE_FILTER = "PARISH_MASS_TYPES_LIST_ACTIVE_FILTER";
export const PARISH_MASS_TYPES_LIST_INACTIVE_FILTER = "PARISH_MASS_TYPES_LIST_INACTIVE_FILTER";
export const PARISH_INTENTION_TYPES_LIST_ACTIVE_FILTER = "PARISH_INTENTION_TYPES_LIST_ACTIVE_FILTER";
export const PARISH_INTENTION_TYPES_LIST_INACTIVE_FILTER = "PARISH_INTENTION_TYPES_LIST_INACTIVE_FILTER";


export const EMP_SETTINGS_TIME_MODEL_ACTIVE_FILTER = "EMP_SETTINGS_TIME_MODEL_ACTIVE_FILTER";
export const EMP_SETTINGS_TIME_MODEL_INACTIVE_FILTER = "EMP_SETTINGS_TIME_MODEL_INACTIVE_FILTER";

export const EMP_SETTINGS_DAY_PLAN_ACTIVE_FILTER = "EMP_SETTINGS_DAY_PLAN_ACTIVE_FILTER";
export const EMP_SETTINGS_DAY_PLAN_INACTIVE_FILTER = "EMP_SETTINGS_DAY_PLAN_INACTIVE_FILTER";

export const EMP_SETTINGS_FLEX_ACTIVE_FILTER = "EMP_SETTINGS_FLEX_ACTIVE_FILTER";
export const EMP_SETTINGS_FLEX_INACTIVE_FILTER = "EMP_SETTINGS_FLEX_INACTIVE_FILTER";


export const TIME_CALENDAR_SEARCH_MONTH = "TIME_CALENDAR_SEARCH_MONTH";
export const TIME_CALENDAR_SEARCH_GROUP = "TIME_CALENDAR_SEARCH_GROUP";
export const TIME_CALENDAR_SEARCH_EMPLOYEE = "TIME_CALENDAR_SEARCH_EMPLOYEE";
export const TIME_CALENDAR_SEARCH_WORK = "TIME_CALENDAR_SEARCH_WORK";


export const FRA_OVERVIEW_SEARCH_ACTIVE = "FRA_OVERVIEW_SEARCH_ACTIVE";
export const FRA_OVERVIEW_SEARCH_INACTIVE = "FRA_OVERVIEW_SEARCH_INACTIVE";
export const FRA_OVERVIEW_SEARCH_MEMBER = "FRA_OVERVIEW_SEARCH_MEMBER"; 
export const FRA_OVERVIEW_SEARCH_NOT_MEMBER = "FRA_OVERVIEW_SEARCH_NOT_MEMBER"; 
export const FRA_OVERVIEW_SEARCH_ORDER_BY_LVE_NUMBER = "FRA_OVERVIEW_SEARCH_ORDER_BY_LVE_NUMBER";
export const FRA_OVERVIEW_SEARCH_TERM = "FRA_OVERVIEW_SEARCH_TERM";

export const FRA_MEMBERSHIP_OVERVIEW_SEARCH_TERM = "FRA_MEMBERSHIP_OVERVIEW_SEARCH_TERM";

export const TREE_CONFIG_OVERVIEW_SEARCH_ACTIVE = "TREE_CONFIG_OVERVIEW_SEARCH_ACTIVE";
export const TREE_CONFIG_OVERVIEW_SEARCH_INACTIVE = "TREE_CONFIG_OVERVIEW_SEARCH_INACTIVE";
export const TREE_CONFIG_OVERVIEW_SEARCH_TEMPLATE = "TREE_CONFIG_OVERVIEW_SEARCH_TEMPLATE";
export const TREE_CONFIG_OVERVIEW_SEARCH_PRODUCTION = "TREE_CONFIG_OVERVIEW_SEARCH_PRODUCTION";
export const TREE_CONFIG_OVERVIEW_SEARCH_TERM = "TREE_CONFIG_OVERVIEW_SEARCH_TERM";

export const TREE_PROJECT_OVERVIEW_SEARCH_ACTIVE = "TREE_PROJECT_OVERVIEW_SEARCH_ACTIVE";
export const TREE_PROJECT_OVERVIEW_SEARCH_INACTIVE = "TREE_PROJECT_OVERVIEW_SEARCH_INACTIVE";
export const TREE_PROJECT_OVERVIEW_SEARCH_TERM = "TREE_PROJECT_OVERVIEW_SEARCH_TERM";
export const TREE_PROJECT_OVERVIEW_SEARCH_CS = "TREE_PROJECT_OVERVIEW_SEARCH_CS";

export const TREE_PROJECT_BRANCH_LIST_FILTER_NAME = "TREE_PROJECT_BRANCH_LIST_FILTER_NANE";
export const TREE_PROJECT_BRANCH_LIST_FILTER_TYPE = "TREE_PROJECT_BRANCH_LIST_FILTER_TYPE";
export const TREE_PROJECT_BRANCH_LIST_FILTER_STATUS = "TREE_PROJECT_BRANCH_LIST_FILTER_STATUS";
export const TREE_PROJECT_BRANCH_LIST_FILTER_SHOW_DELETED = "TREE_PROJECT_BRANCH_LIST_FILTER_SHOW_DELETED";
export const TREE_PROJECT_CODE_FILTER_VISIBLE_STATUS = "TREE_PROJECT_CODE_FILTER_VISIBLE_STATUS";
//export const TREE_PROJECT_BRANCH_LIST_FILTER_ARCHIVE = "TREE_PROJECT_BRANCH_LIST_FILTER_ARCHIVE";


export const DATA_PROJECT_ITEM_LIST_FILTER_SEARCH_TERM = "DATA_PROJECT_ITEM_LIST_FILTER_SEARCH_TERM";
export const DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER1 = "DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER1";
export const DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER2 = "DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER2";
export const DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER3 = "DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER3";
export const DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER4 = "DATA_PROJECT_ITEM_LIST_FILTER_IS_QUARTER4";


export const TODO_ITEM_LIST_FILTER_STATUSES = "TODO_ITEM_LIST_FILTER_STATUSES";
export const TODO_ITEM_LIST_FILTER_TYPES = "TODO_ITEM_LIST_FILTER_TYPES";
export const TODO_ITEM_LIST_FILTER_STARTING = "TODO_ITEM_LIST_FILTER_STARTING";
export const TODO_ITEM_LIST_FILTER_ENDING = "TODO_ITEM_LIST_FILTER_ENDING";
export const TODO_ITEM_LIST_FILTER_COLLAPSED = "TODO_ITEM_LIST_FILTER_COLLAPSED";


export const DATA_PROJECT_ITEM_LIST_FILTER_CHANGE_STARTING = "DATA_PROJECT_ITEM_LIST_FILTER_CHANGE_STARTING";
export const DATA_PROJECT_ITEM_LIST_FILTER_CHANGE_ENDING = "DATA_PROJECT_ITEM_LIST_FILTER_CHANGE_ENDING";
export const DATA_PROJECT_ITEM_LIST_FILTER_MULTI_SELECT_STATUS = "DATA_PROJECT_ITEM_LIST_FILTER_MULTI_SELECT_STATUS";


export const DATA_PROJECT_TREE_FILTER_MULTI_SELECT_STATUS = "DATA_PROJECT_TREE_FILTER_MULTI_SELECT_STATUS";
export const DATA_PROJECT_TREE_FILTER_MULTI_SELECT_TRAFFICLIGHT = "DATA_PROJECT_TREE_FILTER_MULTI_SELECT_TRAFFICLIGHT";
export const DATA_PROJECT_TREE_FILTER_SHOW_ARCHIVED_STATUS = "DATA_PROJECT_TREE_FILTER_SHOW_ARCHIVED_STATUS";
export const DATA_PROJECT_TREE_BRANCH_ONLY_NOT_NULL = "DATA_PROJECT_TREE_BRANCH_ONLY_NOT_NULL";
export const DATA_PROJECT_TREE_FILTER_COLLAPSED = "DATA_PROJECT_TREE_FILTER_COLLAPSED";


export const TREE_PROJECT_AUTO_HIDE = "TREE_PROJECT_AUTO_HIDE";


export const CONV_OVERVIEW_CHECKBOX_OPEN = "CONV_OVERVIEW_CHECKBOX_OPEN";
export const CONV_OVERVIEW_CHECKBOX_ELABORATION = "CONV_OVERVIEW_CHECKBOX_ELABORATION";
export const CONV_OVERVIEW_CHECKBOX_CLOSE = "CONV_OVERVIEW_CHECKBOX_CLOSE";
export const CONV_OVERVIEW_CHECKBOX_ERROR = "CONV_OVERVIEW_CHECKBOX_ERROR";
export const CONV_OVERVIEW_CHECKBOX_DELETE_REQUEST = "CONV_OVERVIEW_CHECKBOX_DELETE_REQUEST";
export const CONV_OVERVIEW_CHECKBOX_DELETE = "CONV_OVERVIEW_CHECKBOX_DELETE";
export const CONV_OVERVIEW_SEARCH_TERM = "CONV_OVERVIEW_CHECKBOX_SEARCH_TERM";


export const EMP_OVERVIEW_SEARCH_ACTIVE = "EMP_OVERVIEW_SEARCH_ACTIVE";
export const EMP_OVERVIEW_SEARCH_INACTIVE = "EMP_OVERVIEW_SEARCH_INACTIVE";
export const EMP_OVERVIEW_SEARCH_TEXT = "EMP_OVERVIEW_SEARCH_TEXT";



export const TODO_OVERVIEW_FILTER_OPEN = "TODO_OVERVIEW_FILTER_OPEN";
export const TODO_OVERVIEW_ALERT_FILTER = "TODO_OVERVIEW_ALERT_FILTER";             /*deprecated*/
export const TODO_OVERVIEW_TASK_FILTER = "TODO_OVERVIEW_INFO_FILTER";               /*deprecated*/
export const TODO_OVERVIEW_OTHER_FILTER = "TODO_OVERVIEW_OTHER_FILTER";             /*deprecated*/

export const TODO_OVERVIEW_CHECK_TODO_FILTER = "TODO_OVERVIEW_CHECK_TODO_FILTER";   /*deprecated*/
export const TODO_OVERVIEW_CHECK_OBJECT_FILTER = "TODO_OVERVIEW_CHECK_OBJECT_FILTER";   /*deprecated*/

export const TODO_OVERVIEW_TEXT_FILTER = "TODO_OVERVIEW_TEXT_FILTER";
export const TODO_OVERVIEW_STARTING_FILTER = "TODO_OVERVIEW_STARTING_FILTER";
export const TODO_OVERVIEW_ENDING_FILTER = "TODO_OVERVIEW_ENDING_FILTER";

export const TODO_OVERVIEW_STARTING_OBJECT_FILTER = "TODO_OVERVIEW_STARTING_OBJECT_FILTER";     /*deprecated*/
export const TODO_OVERVIEW_ENDING_OBJECT_FILTER = "TODO_OVERVIEW_ENDING_OBJECT_FILTER";         /*deprecated*/

export const TODO_OVERVIEW_STATUS_FILTER = "TODO_OVERVIEW_STATUS_FILTER";
export const TODO_OVERVIEW_SHOW_NOT_ASSIGNED_FILTER = "TODO_OVERVIEW_SHOW_NOT_ASSIGNED_FILTER";

export const TODO_OVERVIEW_RESPONSIBLE = "TODO_OVERVIEW_RESPONSIBLE";
export const TODO_OVERVIEW_MONITORING = "TODO_OVERVIEW_MONITORING";

export const TODO_OVERVIEW_FLAG = "TODO_OVERVIEW_FLAG";
export const TODO_OVERVIEW_PERSONAL_FLAG = "TODO_OVERVIEW_PERSONAL_FLAG";

export const TODO_OVERVIEW_MODULE_FILTER = "TODO_OVERVIEW_MODULE_FILTER";
export const TODO_OVERVIEW_DETAILTYPE_FILTER = "TODO_OVERVIEW_DETAILTYPE_FILTER";
export const TODO_OVERVIEW_PROJECT_FILTER = "TODO_OVERVIEW_PROJECT_FILTER";
export const TODO_OVERVIEW_TODO_FILTER = "TODO_OVERVIEW_TODO_FILTER";


export const DATA_SEARCH_CREATD_FROM_FILTER = "DATA_SEARCH_CREATD_FROM_FILTER";
export const DATA_SEARCH_CREATED_TO_FILTER = "DATA_SEARCH_CREATED_TO_FILTER";
export const DATA_SEARCH_VALID_FROM_FILTER = "DATA_SEARCH_VALID_FROM_FILTER";
export const DATA_SEARCH_VALID_TO_FILTER = "DATA_SEARCH_VALID_TO_FILTER";
export const DATA_SEARCH_STATUS_FILTER = "DATA_SEARCH_STATUS_FILTER";
export const DATA_SEARCH_MODULE_FILTER = "DATA_SEARCH_MODULE_FILTER";
export const DATA_SEARCH_KEYWORD_LIST = "DATA_SEARCH_KEYWORD_LIST";
export const DATA_SEARCH_DETAIL_TYPE_FILTER = "DATA_SEARCH_DETAIL_TYPE_FILTER";
export const DATA_SEARCH_PROJECT_FILTER = "DATA_SEARCH_PROJECT_FILTER";
export const DATA_SEARCH_TEXT_FILTER = "DATA_SEARCH_TEXT_FILTER";
export const DATA_SEARCH_SHOW_NOTIFICATION_FILTER = "DATA_SEARCH_SHOW_NOTIFICATION_FILTER";
export const DATA_SEARCH_OPEN_FILTER = "DATA_SEARCH_OPEN_FILTER";



export const DISTRIBUTION_LISTS_ACTIVE = "DISTRIBUTION_LISTS_ACTIVE";
export const DISTRIBUTION_LISTS_INACTIVE = "DISTRIBUTION_LISTS_INACTIVE";
export const DISTRIBUTION_LISTS_SEARCH_TEXT = "DISTRIBUTION_LISTS_SEARCH_TEXT";


export const COMMUNICATION_OVERVIEW_FROM = "COMMUNICATION_OVERVIEW_FROM";
export const COMMUNICATION_OVERVIEW_TO = "COMMUNICATION_OVERVIEW_TO";
export const COMMUNICATION_OVERVIEW_TYPE = "COMMUNICATION_OVERVIEW_TYPE";
export const COMMUNICATION_OVERVIEW_SEARCH_TEXT = "COMMUNICATION_OVERVIEW_SEARCH_TEXT";
export const COMMUNICATION_OVERVIEW_SEARCH_VISIBILITY = "COMMUNICATION_OVERVIEW_SEARCH_VISIBILITY";

export const COMMUNICATION_ADMINISTRATION_SEARCH_TEXT = "COMMUNICATION_ADMINISTRATION_SEARCH_TEXT";
export const COMMUNICATION_ADMINISTRATION_ACTIVE = "COMMUNICATION_ADMINISTRATION_ACTIVE";
export const COMMUNICATION_ADMINISTRATION_INACTIVE = "COMMUNICATION_ADMINISTRATION_INACTIVE";
export const COMMUNICATION_ADMINISTRATION_FROM = "COMMUNICATION_ADMINISTRATION_FROM";
export const COMMUNICATION_ADMINISTRATION_TO = "COMMUNICATION_ADMINISTRATION_TO";
export const TODO_ORDER_OVERVIEW_SEARCH_ACTIVE = "TODO_ORDER_OVERVIEW_SEARCH_ACTIVE";
export const TODO_ORDER_OVERVIEW_SEARCH_INACTIVE = "TODO_ORDER_OVERVIEW_SEARCH_INACTIVE";
export const TODO_ORDER_OVERVIEW_SEARCH_TERM = "TODO_ORDER_OVERVIEW_SEARCH_TERM";
export const TODO_ORDER_OVERVIEW_SEARCH_CS = "TODO_ORDER_OVERVIEW_SEARCH_CS";
export const TODO_ORDER_OVERVIEW_SEARCH_FRA = "TODO_ORDER_OVERVIEW_SEARCH_FRA";
export const COMMUNICATION_ADMINISTRATION_TYPE = "COMMUNICATION_ADMINISTRATION_TYPE";



export const EMPLOYEE_HISTORY_MONTH = "EMPLOYEE_HISTORY_MONTH";
export const EMPLOYEE_HISTORY_ACTIVE = "EMPLOYEE_HISTORY_ACTIVE";
export const EMPLOYEE_HISTORY_INACTIVE = "EMPLOYEE_HISTORY_INACTIVE";
export const EMPLOYEE_HISTORY_TIME_TRACKING_ACTIVE = "EMPLOYEE_HISTORY_TIME_TRACKING_ACTIVE";
export const EMPLOYEE_HISTORY_TIME_TRACKING_INACTIVE = "EMPLOYEE_HISTORY_TIME_TRACKING_INACTIVE";


export const TEAM_VACATION_OVERVIEW_COLUMN_MODE = "TEAM_VACATION_OVERVIEW_COLUMN_MODE";


export const TIME_TRACK_CURRENT_LIST_ORDER_BY_LASTNAME = "TIME_TRACK_CURRENT_LIST_ORDER_BY_LASTNAME";
export const TIME_TRACK_CURRENT_LIST_CHECKED_IN = "TIME_TRACK_CURRENT_LIST_CHECKED_IN";
export const TIME_TRACK_CURRENT_LIST_CHECKED_OUT = "TIME_TRACK_CURRENT_LIST_CHECKED_OUT";
export const TIME_TRACK_CURRENT_LIST_BREAK_TIME = "TIME_TRACK_CURRENT_LIST_BREAK_TIME";
export const TIME_TRACK_CURRENT_LIST_SEARCH_TERM = "TIME_TRACK_CURRENT_LIST_SEARCH_TERM";
export const TIME_TRACK_CURRENT_LIST_GROUP = "TIME_TRACK_CURRENT_LIST_GROUP";


export const TIMEMANAGER_MONTH_DAY_SWITCH = "TIMEMANAGER_MONTH_DAY_SWITCH";
export const TIMEMANAGER_DATE = "TIMEMANAGER_DATE";
export const TIMEMANAGER_MONTH = "TIMEMANAGER_MONTH";
export const TIMEMANAGER_EMPLOYEE_RID = "TIMEMANAGER_EMPLOYEE_RID";


export const TEAM_END_OF_MONTH_OVERVIEW_MONTH = "TEAM_END_OF_MONTH_OVERVIEW_MONTH";
export const TEAM_END_OF_MONTH_OVERVIEW_OPEN = "TEAM_END_OF_MONTH_OVERVIEW_OPEN";
export const TEAM_END_OF_MONTH_OVERVIEW_CLOSE_BY_EMP = "TEAM_END_OF_MONTH_OVERVIEW_CLOSE_BY_EMP";
export const TEAM_END_OF_MONTH_OVERVIEW_CLOSE_BY_TL = "TEAM_END_OF_MONTH_OVERVIEW_CLOSE_BY_TL";
export const TEAM_END_OF_MONTH_OVERVIEW_CLOSE_BY_HR = "TEAM_END_OF_MONTH_OVERVIEW_CLOSE_BY_HR";
export const TEAM_END_OF_MONTH_OVERVIEW_TEXT_FILTER = "TEAM_END_OF_MONTH_OVERVIEW_TEXT_FILTER";


export const TEAM_END_OF_MONTH_OVERVIEW_DATE = "TEAM_END_OF_MONTH_OVERVIEW_DATE";


export const MAX_FILE_UPLOAD_SIZE = "MAX_FILE_UPLOAD_SIZE";
export const LEFT_SIDE_MENU_IS_MINIMIZED = "LEFT_SIDE_MENU_IS_MINIMIZED";


export const PROGRAM_VERSION = "PROGRAM_VERSION";

export const SYS_TEAMAPI7URL = "SYS_TEAMAPI7URL";